import React from "react";
import './IPSVersionUp.css';

const IPSVersionUp = () => {
    return (
        <div className="ips-version-up-wrapper">
            <h1>Please Update the App.</h1>
            <p>You are currently using an outdated version of this app. In order to securely log in to your account, you
will need to install the most recent app update.</p>
            <div className="best-experiece-points-wrapper">
                <p>For the best experience, update the app and register your printer to receive:</p>
                <ul>
                    <li><b>PERSONALIZED SAVINGS</b> on Brother Genuine ink & toner</li>
                    <li><b>FREE</b> 6-month extended limited warranty for eligible printers</li>
                </ul>
            </div>
            <div className="update-steps-wrapper">
                <h3>3 easy steps to update your IP&S app:</h3>
                <ol>
                    <li>Close this window, and go to your Settings</li>
                    <li>
                        <ul>
                            <li>For v11 or below → click on <b>Product Information</b></li>
                            <li>For v12 or above → click on <b>App Settings &gt; General</b></li>
                        </ul>
                    </li>
                    <li>Click on “Check for Software Update”</li>
                </ol>
            </div>
        </div>
    )
}

export default IPSVersionUp;